/**
 * @generated SignedSource<<55714f2c2460e374783c0b1feae590b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type footerRenderer_nativeIssueTable_issues$data = {
  readonly totalIssueSearchResultCount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateFooter_nativeIssueTable_issues" | "main_nativeIssueTable_IssueCountRenderer" | "paginationControls_nativeIssueTable">;
  readonly " $fragmentType": "footerRenderer_nativeIssueTable_issues";
};
export type footerRenderer_nativeIssueTable_issues$key = {
  readonly " $data"?: footerRenderer_nativeIssueTable_issues$data;
  readonly " $fragmentSpreads": FragmentRefs<"footerRenderer_nativeIssueTable_issues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    }
  ],
  "kind": "Fragment",
  "name": "footerRenderer_nativeIssueTable_issues",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_nativeIssueTable_IssueCountRenderer"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueCreateFooter_nativeIssueTable_issues"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "pageSize"
        }
      ],
      "kind": "FragmentSpread",
      "name": "paginationControls_nativeIssueTable"
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueSearchResultCount"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "b33af498ce59c9940c71b520b1fb07ca";

export default node;
